import { Guid, ObjectType, RecursivePartial } from '@models/base';
import { BaseTaskAction, TaskActionType } from './_base-task-action';
import { VzParamType } from '@models/params/param-type';

export class TaskActionCustomValue extends BaseTaskAction {
    type: TaskActionType.CustomValue = TaskActionType.CustomValue;
    fieldId?: Guid;
    valueType?: VzParamType;
    objectType?: ObjectType;
    icon?: string;
    color?: string;
    name?: string;
    value?: any;

    constructor(json?: RecursivePartial<TaskActionCustomValue>) {
        super(json);
        this.parseTaskActionCustomValue(json || {});
    }

    parse(json: RecursivePartial<TaskActionCustomValue>): TaskActionCustomValue {
        super.parse(json);
        this.parseTaskActionCustomValue(json);
        return this;
    }

    private parseTaskActionCustomValue(json: RecursivePartial<TaskActionCustomValue>): void {
        TaskActionCustomValue.assignFields<TaskActionCustomValue>(this, json, [
            'fieldId',
            'valueType',
            'objectType',
            'icon',
            'color',
            'name',
            'value',
        ]);
        if (json.value === null) {
            this.value = null;
        }
        if (this.valueType == VzParamType.Date) {
            try {
                this.value = Date.parse(this.value);
            } catch {}
        }
    }
}
